<template>
    <div class="row pt-3">
        <calendar></calendar>
    </div>
</template>

<script>
import Calendar from '@/components/Calendar/Calendar.vue'
export default {
    components: {
        Calendar,
    },
    mixins: [],
    data() {
        return {
        }
    },
    computed: {

    },
    created() {

    },
    methods: {
    }
}
</script>